import * as React from 'react';

import emtyOrders from 'src/assets/emptyOrders';
import noResultsOrders from 'src/assets/noResultsOrders';
import './EmptyOrders.scss';
import emptyorders from 'src/assets/emptyOrders';
import i18n from 'src/translation/i18n';

interface IEmptyOrdersProps {
  noResults: boolean;
}

class EmptyOrders extends React.Component<IEmptyOrdersProps, any> {
  public render() {
    return (
      <div className="rp-empty-orders">
        <div
          className="image"
          style={{
            backgroundImage: `url(${
              this.props.noResults ? noResultsOrders : emptyorders
            })`
          }}
        />
        <div className="rp-empty-orders--title">
          {this.props.noResults
            ? `${i18n.t('myOrders.noresultsFoundTxt')}`
            : `${i18n.t('myOrders.noOrders')}`}
        </div>
        <div className="rp-empty-orders--subtitle">
          {this.props.noResults
            ? `${i18n.t('myOrders.pleaseTryAgainTxt')}`
            : `${i18n.t('myOrders.ordersAppearHere')}`}
        </div>
      </div>
    );
  }
}

export default EmptyOrders;
